class FeedbackView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      reason: this.props.reason,
      message: this.props.message,
      contactMode: "EMAIL",
      contactName: "",
      contactDetail: ""
    };
  }

  setReason(evt) {
    this.setState({
      reason: evt.target.value
    });
  }

  setMessage(evt) {
    this.setState({
      message: evt.target.value
    });
  }

  setContactMode(evt) {
    this.setState({
      contactMode: evt.target.value
    });
  }

  setContactDetail(evt) {
    this.setState({
      contactDetail: evt.target.value
    });
  }

  setContactName(evt) {
    this.setState({
      contactName: evt.target.value
    });
  }

  submit() {
    let { message, reason, contactMode, contactName, contactDetail } = this.state;
    let { onSubmit } = this.props;

    let serialize = function (obj) {
      return Object.keys(obj).map((key) => key + ": " + obj[key]).join("\n");
    };

    let data;
    let msg = message.trim();
    let title = msg.length < 100 ? msg : msg.substr(0, 100) + "...";
    let details = {
      "Reason for Contact": reason,
      "Contact Method": contactMode,
      "Contact Name": contactName,
      "Contact Detail": contactDetail,
      "Browser": navigator.userAgent,
      "Language": navigator.language,
      "Build": window.APP_REV
    };

    if (msg.length) {
      data = {
        title: title,
        feedback: [msg, serialize(details)].join("\n--\n"),
        href: location.href
      };

      this.setState({
        submitting: true
      });

      mc.ajax.post("/users/feedback", data)
        .then(onSubmit)
        .catch(() => {
          mc.ui.alert("Oh no! There was a problem submitting this form. Please contact us at 857-214-5630 or support@mc10inc.com.", { level: "error" });
          this.setState({
            submitting: false
          });
        });
    }
  }

  static open(reason, message) {
    let onSubmit = function () {
      mc.ui.modal(null);
      mc.ui.alert("Thanks for your feedback!");
    };

    mc.ui.modal(<FeedbackView reason={reason} message={message} onSubmit={onSubmit}/>, { width: "550px" });
  }

  render() {
    let {
      message,
      reason,
      contactMode,
      contactDetail,
      contactName
    } = this.state;

    let hint = {
      EMAIL: "E-mail address",
      PHONE: "Phone number"
    }[contactMode];

    return (
      <div className="rc-feedback-view">
        <h1>{"Contact Us"}</h1>
        <p>Need help or have a product suggestion? Let us know! You may also reach us at <a href="mailto:biostamp-support@mdsol.com">biostamp-support@mdsol.com</a>. In the US, call 877-338-2778. A full listing of local support numbers can be found <a href="https://support.mdsol.com/hc/en-us/articles/205359417-Medidata-Helpdesk-Support-Telephone-Numbers#patient_cloud_numbers" target="_blank">here</a>. When calling, use code 628 to direct your inquiries to BioStamp support.</p>
        
        
        <div className="mc-form">
          <div className="mc-form-row">
            <div className="mc-form-label">{"Subject"}</div>
            <select value={reason} onChange={(e) => this.setReason(e)}>
              <option value="GETTING_STARTED">{"I need help getting started"}</option>
              <option value="TECH_SUPPORT">{"I need technical support"}</option>
              <option value="SUGGESTION">{"I have a product suggestion"}</option>
              <option value="BILLING">{"I have a billing question"}</option>
              <option value="OTHER">{"Other"}</option>
            </select>
          </div>
          <div className="mc-form-row">
            <div className="mc-form-label">{"Message"}</div>
            <textarea ref="message" rows="5" cols="30" value={message} onChange={(e) => this.setMessage(e)}/>
          </div>
          <div className="mc-form-row">
            <div className="mc-form-label">{"Would you like us to contact you?"}</div>
            <select value={contactMode} onChange={(e) => this.setContactMode(e)}>
              <option value="EMAIL">{"Yes, by email"}</option>
              <option value="PHONE">{"Yes, by phone"}</option>
              <option value="NONE">{"No, thanks"}</option>
            </select>
            {contactMode !== "NONE" && (
              <input type="text" size="24" value={contactDetail} onChange={(e) => this.setContactDetail(e)} placeholder={hint}/>
            )}
          </div>
          <div className="mc-form-row">
            <div className="mc-form-label">{"Your name"}</div>
            <input type="text" size="28" value={contactName} onChange={(e) => this.setContactName(e)}/>
          </div>
        </div>
        <button className="mc-button" onClick={(e) => this.submit(e)} disabled={message.trim().length === 0 || this.state.submitting}>
          {"Submit"}
        </button>
      </div>
    );
  }
}

FeedbackView.defaultProps = {
  reason: "GETTING_STARTED",
  message: ""
};

window.FeedbackView = FeedbackView;

module.exports = FeedbackView;
